<template>
    <div class="box">

      <b-tabs v-model="selectedTab">
        <b-tab-item>
            <template slot="header">
                <b-icon icon="pencil"></b-icon>
                <span>Text post</span>
            </template>

            <div class="content">
              <b-field label="Write a new post">
                <b-input v-model="content" type="textarea" placeholder="Write your new post here"></b-input>
              </b-field>
            </div>
        </b-tab-item>
        <b-tab-item>
            <template slot="header">
                <b-icon icon="spotlight-beam"></b-icon>
                <span>Project spotlight</span>
            </template>

            <div class="content">
              <b-field label="Write a new post">
                <b-input v-model="content" type="textarea" placeholder="Write your new post here"></b-input>
              </b-field>
            </div>

            <strong>Spotlight a project</strong>
            <p>To spotlight a project, click on the box below to select one</p>
            <div class="field has-addons">
              <div class="control">
                  <a class="button is-static">Spotlight</a>
              </div>
              <div class="control">
                <input @click="isModalActive = true" class="input" type="text"
                  :value="spotlightedProject.name"
                  placeholder="(None)"
                  readonly
                >
              </div>
              <div class="control">
                <a class="button" @click="spotlightedProject = {}" :disabled="!spotlightedProject.id">
                  X
                </a>
              </div>
            </div>
        </b-tab-item>
      </b-tabs>

      <b-modal :active.sync="isModalActive" has-modal-card>
        <div class="modal-card">
            <div class="modal-card-body">
                <b-field label="Search for a project">
                    <b-input type="text" v-model="searchText" @input="searchProjects()" placeholder="Begin typing a project name"></b-input>
                </b-field>

                <a v-for="project in filteredProjects" :key="project.id" @click="selectProject(project)">
                    <article class="media">
                      <figure class="media-left">
                        <p class="image is-64x64">
                          <img :src="project.image">
                        </p>
                      </figure>
                      <div class="media-content">
                        <div class="content">
                          <strong>{{project.name}}</strong>
                          <p>{{project.pitch}}</p>
                        </div>
                      </div>
                    </article>
                </a>
            </div>
        </div>
      </b-modal>

      <b-notification type="is-danger" v-if="errorText">
        {{errorText}}
      </b-notification>
      <a class='button is-info is-pulled-right' :disabled="!this.content" @click="savePost()">Post</a>
      <span class='is-clearfix'></span>

    </div>
</template>

<style scoped>
    .box { width: 85%; }
    a > .media { color: #4a4a4a; }
    article span.tag { float: right; }
</style>

<script>
export default {
  name: 'NewPost',
  props: ['projects', 'universityId'],
  data () {
    return {
      content: '',
      selectedTab: 0,
      isModalActive: false,
      searchText: '',
      errorText: null,
      spotlightedProject: {
        id: null
      },
      filteredProjects: this.projects.slice(0,3)
    }
  },
  methods: {
    searchProjects() {
        this.filteredProjects = this.projects.filter((project) => {
            return project
                .name
                .toString()
                .toLowerCase()
                .indexOf(this.searchText.toLowerCase()) >= 0
        }).slice(0,3);
    },
    selectProject(project) {
        this.spotlightedProject = project;
        this.isModalActive = false;
        this.searchText = '';
        this.filteredProjects = this.projects.slice(0,3); // reset search results
    },
    savePost() {
        if(!this.content) return false; // content is required
        
        var data = { text: this.content };
        if(this.selectedTab === 1) data.highlightedProject = this.spotlightedProject.id;

        this.errorText = null;
        this.$http.post(this.$hostname + '/posts/university/' + this.universityId, data).then(function(response) {
            if(response.status === 200) {
                this.selectedTab = 0;
                this.content = '';
                this.spotlightedProject = {};
                this.$emit('create-post', response.body); // send message to parent that the Post was created; body contains Post data
            }
            else {
                this.errorText = 'An error occurred while creating this post. Verify you are logged in. If this problem persists, contact a system administrator';
            }
        }).catch(function(error) {
            this.errorText = 'An error occurred while creating this post. Verify you are logged in. If this problem persists, contact a system administrator';
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewPost.vue